// Utility function for easing (gentleEaseOutIn)
export function gentleEaseOutIn(t) {
    // Cubic easing keeps start/end movement subtle while preserving a smooth midpoint.
    return t < 0.5 ? 0.5 * (1 - Math.pow(1 - 2 * t, 3)) : 0.5 * (Math.pow(2 * t - 1, 3) + 1);
}

// Utility function for handling scroll and applying parallax effect
export function handleScroll(refs, maxTop = 192, minTop = -96) {
    const textContainer = refs.textContainer;
    const element = refs.element;

    if (textContainer && element) {
        const elementRect = element.getBoundingClientRect();
        const scrollPosition = window.scrollY || window.pageYOffset;
        const elementTop = elementRect.top + scrollPosition;
        const windowHeight = window.innerHeight;

        // Calculate how much of the element is in view
        const scrollFraction = (scrollPosition + windowHeight - elementTop) / (windowHeight + element.offsetHeight);

        // Clamp the scrollFraction between 0 and 1
        const clampedScrollFraction = Math.max(0, Math.min(1, scrollFraction));

        // Apply easing to make the movement smoother
        const easedScrollFraction = gentleEaseOutIn(clampedScrollFraction);

        // Calculate the new top value using the eased fraction
        const newTop = maxTop - (maxTop - minTop) * easedScrollFraction;

        // Apply the new top value to the text container
        textContainer.style.top = `${newTop}px`;
    }
}
